// extracted by mini-css-extract-plugin
module.exports = {"wrap":"sj","subtitle":"tj","contentWrap":"uj","imgWrap":"vj","heading":"wj","copy":"xj"};